import axios from 'axios';
import {api} from '../utils/helper';

//****************** GET Tables by Selected Project and Org filter by orgDBs ******************//
export const exportByProjectDashboard = async (a) => {
    try{
     // const a = { orgID: sessionStorage.getItem('org'), projID: sessionStorage.getItem('project')}
    const resrep = await axios.post(
      `${api}/exportbyprojectdashboard`, a,
      {
        headers: {
          authorization: sessionStorage.getItem('token'),
        },
      },
    );
//          console.log(`exportbyprojectdashboard controller res: `, resrep);
          return resrep;
    }catch (error) {
//        console.log(`exportbyprojectdashboard controller error: `, error?.response?.data);
        alert(error?.response?.data?.message);
    }

}